// src/components/structure/StructureHeader.js
import { useLocale } from '../../contexts/LocaleContext';
import { useAppConfig } from '../../contexts/AppConfigContext';
import { HeaderRow, HeaderStartCell } from '../../styles/controllerPageStyles';
import DraggableHeaderCell from './DraggableHeaderCell';

const StructureHeader = ({
  columns,
  canEditColumns,
  onDeleteColumn,
  onInsertColumn,
  onRenameColumn,
}) => {
  const { t } = useLocale();
  const { config: appConfig } = useAppConfig();

  const { requiredLevelKey = 'level', requiredTimeKey = 'time' } = appConfig || {};

  return (
    <thead>
      <HeaderRow>
        <HeaderStartCell> </HeaderStartCell>
        
        {columns.map((col, index) => {
          const isFixed = col.label === requiredLevelKey || col.label === requiredTimeKey;
          const displayColName = t(col.label) || col.label;

          return (
            <DraggableHeaderCell
              key={col.id}
              id={col.id}
              colName={displayColName}
              isFixedColumn={isFixed}
              canEditColumns={canEditColumns}
              onDeleteColumn={() => onDeleteColumn(index)}
              onInsertColumn={() => onInsertColumn(index)}
              onRenameColumn={(newLabel) => onRenameColumn(col.id, newLabel)}
            />
          );
        })}
        <HeaderStartCell> </HeaderStartCell>
      </HeaderRow>
    </thead>
  );
};

export default StructureHeader;
